import React, { Component } from 'react';

class INDEX extends Component {

    componentDidMount(){
        this.props.history.push('/')
    }
    
    render() {
        return (
            <div>
                
            </div>
        );
    }
}

export default INDEX;